export const inputsCustomizations = (mode) => ({
  MuiCheckbox: {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        padding: 0,
        '&.Mui-checked': {
          color: mode === 'dark' ? '#f5f6fa' : '#333333',
        },
        '&.Mui-disabled': {
          color: 'rgba(0, 0, 0, 0.38)',
        },
      },
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        textTransform: 'none',
        borderRadius: 8,
      },
    },
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        '&:before': {
          borderBottom: 'none',
        },
        '&:after': {
          borderBottom: 'none',
        },
        '&:hover:before': {
          borderBottom: 'none !important',
        },
        borderRadius: 4, // Change as needed
      },
    },
  },
  MuiToggleButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        textTransform: 'none',
        borderRadius: 8,
      },
    },
  },
});
